module.exports = {"MiniBag":{"Color":"Color"},"SearchBar":{"RecentSearches":"Recent searches"},"Icon":{"Bag":"Cart"}}


//////////////////
// WEBPACK FOOTER
// ../i18n/en-us.json
// module id = ../i18n/en-us.json
// module chunks = client.sitechrome